import Vue from 'vue';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { handleAPIError, ERROR_TYPE } from '@/utils/errorHelper';
import { smartFocus } from '@/utils/uiHelper';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';

// @vue/component
export default {
  name: 'SAMLForm',
  components: {
    PageHeader,
    Loading,
  },
  data() {
    return {
      email: '',

      formError: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      samlURL: 'samlURL',
    }),
    canSubmit() {
      return this.email.length > 0;
    },
  },
  methods: {
    onSubmit() {
      if (!this.canSubmit) return;

      this.formError = '';
      this.isLoading = true;

      axios.get(`/launchpad/saml/account.json?userEmail=${this.email}`).then((response) => {
        this.$store.commit('setSAMLBaseURL', response.data.baseHref);
        Vue.nextTick(() => {
          window.location.href = this.samlURL;
        });
      }).catch((e) => {
        const err = handleAPIError(
          this.$store, e,
          'No associated accounts found, please double-check your email address.',
        );
        if (err && err.type === ERROR_TYPE.FORM_ERROR) this.formError = err.err;
        this.isLoading = false;
        smartFocus();
      });
    },
    reload() {
      window.location.reload();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/sections/Login/SAMLForm/SAMLForm.js